// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from "@/layout";
var storeRouter = {
  path: "/store",
  component: Layout,
  redirect: "/store/index",
  name: "Store",
  meta: {
    title: "商品",
    icon: "clipboard"
  },
  children: [{
    path: "brand",
    component: function component() {
      return import("@/views/store/brand/index");
    },
    name: "StoreBrand",
    meta: {
      title: "品牌管理",
      icon: ""
    }
  }, {
    path: "brandMemberProduct",
    component: function component() {
      return import("@/views/store/brandMemberProduct/index.vue");
    },
    name: "brandMemberProduct",
    meta: {
      title: "工厂价格库"
    }
  }, {
    path: "brand/approve",
    component: function component() {
      return import("@/views/store/approve/index");
    },
    name: "StoreApprove",
    meta: {
      title: "品牌审核",
      icon: ""
    }
  }, {
    path: "index",
    component: function component() {
      return import("@/views/store/index");
    },
    name: "StoreIndex",
    meta: {
      title: "商品管理",
      icon: ""
    }
  }, {
    path: "sort",
    component: function component() {
      return import("@/views/store/sort/index");
    },
    name: "Sort",
    meta: {
      title: "商品分类",
      icon: ""
    }
  }, {
    path: "attr",
    component: function component() {
      return import("@/views/store/storeAttr/index");
    },
    name: "SortAttr",
    meta: {
      title: "商品规格",
      icon: ""
    }
  }, {
    path: "comment",
    component: function component() {
      return import("@/views/store/storeComment/index");
    },
    name: "StoreComment",
    meta: {
      title: "商品评论",
      icon: ""
    }
  }, {
    path: "list/creatProduct/:id?/:isDisabled?",
    component: function component() {
      return import("@/views/store/creatStore/index");
    },
    name: "SortCreat",
    meta: {
      title: "商品添加",
      noCache: true,
      activeMenu: "/store/index"
    },
    hidden: true
  }, {
    path: "list/product/create",
    component: function component() {
      return import("@/views/store/creatStore/default");
    },
    name: "productCreate",
    meta: {
      title: "商品添加",
      noCache: true,
      activeMenu: "/store/index"
    },
    hidden: true
  }, {
    path: "list/product/createCourse",
    component: function component() {
      return import("@/views/store/creatStore/course");
    },
    name: "productCreateCourse",
    meta: {
      title: "在线课程",
      noCache: true,
      activeMenu: "/store/index"
    },
    hidden: true
  }, {
    path: "product/approve",
    component: function component() {
      return import("@/views/store/productApprove");
    },
    name: "productApprove",
    meta: {
      title: "商品审核"
    },
    hidden: true
  }, {
    path: "material",
    component: function component() {
      return import("@/views/store/material/index");
    },
    name: "material",
    meta: {
      title: "品牌素材授权"
    },
    hidden: true
  }]
};
export default storeRouter;